import {
  Control,
  Controller,
  FieldErrors,
  RegisterOptions,
  UseFormRegister,
  UseFormSetValue,
} from "react-hook-form";
import { MenuPlacement } from "react-select";
import { DATA_KEYS, useRemoteData } from "@/utils/useRemoteData";
import { SpotSelect } from "./SelectField";
import { useSpotUser } from "@/utils/spotUser";
import { SimpleGrid } from "../UI/SimpleGrid";

type OptionType = {
  label: string;
  value: string;
  icon?: string;
  description?: string;
  bigIcon?: boolean;
};
interface ISpotSelect {
  name?: string;
  value?: string | { label: string; value: string };
  placeholder?: string;
  label?: string;
  tooltip?: string;
  defaultValue?: OptionType;
  helperText?: string;
  isLoading?: boolean;
  isDisabled?: boolean;
  placement?: MenuPlacement;
  isClearable?: boolean;
  isNotSearchable?: boolean;
  isOptional?: boolean;
  onChange?: (value: any) => void;
  onBlur?: (value: any) => void;
}
interface IUserSelectFieldProps {
  name: string;
  placeholder?: string;
  label?: string;
  helperText?: string;
  tooltip?: string;
  rules?: RegisterOptions;
  control: Control<any>;
  placement?: MenuPlacement;
  isClearable?: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
  isNotSearchable?: boolean;
  isOptional?: boolean;
  onChange?: (value: string) => void;
  defaultValue?: string;
}

export const UserSelect = ({
  value,
  placeholder,
  label,
  onChange,
  isLoading = false,
  isDisabled = false,
  isOptional = false,
}: ISpotSelect) => {
  const { spotGroup } = useSpotUser();
  const { data: usersData } = useRemoteData(DATA_KEYS.USERS, {
    query: { group_id: spotGroup?.id },
  });

  const options = usersData?.items.map((user) => ({
    label: user.user.display_name,
    value: user.user.id,
    icon: user.user.image || undefined,
  }));

  return (
    <SpotSelect
      options={options || []}
      onChange={onChange}
      value={value}
      label={label}
      placeholder={placeholder}
      isClearable
      isLoading={isLoading}
      isDisabled={isDisabled}
      isOptional={isOptional}
    />
  );
};

export const UserSelectField = (props: IUserSelectFieldProps) => {
  return (
    <Controller
      control={props.control}
      name={props.name}
      defaultValue={props.defaultValue}
      rules={props.rules}
      render={({ field: { onChange, value, onBlur } }) => {
        const handleChange = (value: any) => {
          if (!value) {
            if (props.onChange) props.onChange("");
            onChange("");
            return;
          }
          onChange(Object.keys(value).includes("value") ? value?.value : value);
          if (props.onChange) props.onChange(value.value);
        };

        return (
          <UserSelect
            value={value}
            label={props.label}
            tooltip={props.tooltip}
            helperText={props.helperText}
            placeholder={props.placeholder}
            isDisabled={props.isDisabled}
            placement={props.placement}
            isLoading={props.isLoading}
            isClearable={props.isClearable}
            isNotSearchable={props.isNotSearchable}
            isOptional={props.isOptional}
            onChange={handleChange}
            onBlur={onBlur}
            name={props.name}
          />
        );
      }}
    />
  );
};
